import React from 'react'
import './ColumnsRow.scss'
import PropTypes from 'prop-types'
import {GatsbyImage} from 'gatsby-plugin-image'
import PageComponent from './PageComponent'
import ReactMarkdown from 'react-markdown'
import cmsMarkdownRenderers from '../../helpers/markdown/cmsMarkdownRenderers'
import {Link} from 'gatsby'
import {useTranslation} from 'react-i18next'

const ColumnsRow = ({id, title, columns, backgroundColor, columnsStyle}) => {
    const {t} = useTranslation()
    const hasTitle = !!(title && title.trim())

    return (
        <PageComponent backgroundColor={backgroundColor}>
            <div className={'page__columns-row'}>
                {hasTitle && (
                    <span className={'page__columns-row__title'}>
                        <ReactMarkdown escapeHtml={false} renderers={cmsMarkdownRenderers}>
                            {title}
                        </ReactMarkdown>
                    </span>
                )}
                <div
                    className={`page__columns-row__columns page__columns-style-${columnsStyle}`}
                    style={{'--columns': columns.length}}
                >
                    {columns.map((column) => (
                        <React.Fragment key={`${id}_column-${column.id}`}>
                            <span className={'page__columns-row__column-image'}>
                                {column.imageData && <GatsbyImage image={column.imageData} alt={column.imageAlt} />}
                            </span>
                            <span className={'page__columns-row__column-content'}>
                                <ReactMarkdown escapeHtml={false} renderers={cmsMarkdownRenderers}>
                                    {column.content}
                                </ReactMarkdown>
                                {column.buttonLink && (
                                    <Link to={column.buttonLink} className={'is-block mt-auto'}>
                                        <button className="button is-outlined is-small is-primary is-rounded">
                                            {t('columns-row_show-more')}
                                        </button>
                                    </Link>
                                )}
                            </span>
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </PageComponent>
    )
}

ColumnsRow.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string,
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            content: PropTypes.string,
            imageData: PropTypes.object,
            imageAlt: PropTypes.string,
            buttonLink: PropTypes.string,
        })
    ),
    backgroundColor: PropTypes.string,
    columnsStyle: PropTypes.string,
}

ColumnsRow.defaultProps = {
    title: '',
    columns: [],
    backgroundColor: 'white',
    columnsStyle: 'none',
}

export default ColumnsRow
